// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { getUnitLabelForMetersAndFeet } from 'helpers/unitConversion'

const FormatElevationHeader = ({ unitType }) => (
  <div>{`Elevation (${getUnitLabelForMetersAndFeet(unitType)})`}</div>
)

FormatElevationHeader.propTypes = {
  unitType: string.isRequired,
}

export default FormatElevationHeader
